<template lang="pug">
v-row(no-gutters)
  v-col(cols="2")
    div.d-flex.align-center
      v-icon(color="primary") {{ icon }}
      v-icon(small v-if="blocked" color="primary") {{ mdiBlockHelper }}
  v-col.subtitle-2.font-weight-regular.pb-2(cols="10") {{ text }}
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import { mdiBlockHelper } from "@mdi/js"

export default Vue.extend({
  name: "ItemIconContent",
  props: {
    icon: { type: String, required: true },
    text: { type: String, required: true },
    blocked: { type: Boolean, default: false },
  },
  setup() {
    return {
      mdiBlockHelper,
    }
  },
})
</script>
